import moment from "moment/moment.js";
import { encoded } from "./cryptoUtils";

const getRequestToken = () => {
    const now = moment.utc().format("MMM DD YYYY HH"); // Use UTC and 24-hour format
    return encoded(now + "AbbuKarthik");
};

const getHeaders = () => {
    try {
        const payload = {
            RequestToken: getRequestToken(),
            Authorization: localStorage.getItem("Authorization"),
            menu_id: localStorage.getItem("menu_id"),
            branch_id: localStorage.getItem("branch_id_1"),
            company_id: localStorage.getItem("company_id_1"),
            role: localStorage.getItem("role"),
            type_of_entity: localStorage.getItem("type_of_entity"),
            ip_address: localStorage.getItem("userIp") || "", // Synchronous access
            country: localStorage.getItem("country") || "",
            region: localStorage.getItem("regionName") || "",
            city: localStorage.getItem("city") || "",
            zipcode: localStorage.getItem("zipcode") || "",
            latitude: localStorage.getItem("latitude") || "0",
            longitude: localStorage.getItem("longitude") || "0",
            timezone: localStorage.getItem("timezone") || "Asia/Kolkata",
        };
        //const authorization = localStorage.getItem("Authorization") || getRequestToken();

        const encodedData = encoded(JSON.stringify(payload));

        return {
            Authorization1: getRequestToken(),
            customData: encodedData,
        };
    } catch (error) {
        console.error("Error in getHeaders:", error);
        return null; // Handle errors gracefully
    }
};

export default { getRequestToken, getHeaders };  // Correct export
